/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconRadiusBottomRight = createReactComponent(
  "radius-bottom-right",
  "IconRadiusBottomRight",
  [["path", { d: "M19 5v6a8 8 0 0 1 -8 8h-6", key: "svg-0" }]]
);

export { IconRadiusBottomRight as default };
//# sourceMappingURL=IconRadiusBottomRight.js.map
